function bestSkiMomentsCards() {
    const arr = bestSkiMomentsData;
    const cards = arr.map(
        (item) =>
            `
            <div class="embla__slide embla__slide--bestSkiMoments">
                <img src="${item}" alt="best ski image" class="db obj-fit-cover obj-position-center pos-absolute top-0 left-0 w-full h-full">
            </div>`
    );

    const layout = $(`.js-best-ski-moments-wrapper`).append(cards);
    $(document).trigger('layoutForBestSkiMomentsEmblaIsCreated');
    return layout;
}

runIfElementExist(bestSkiMomentsCards, '.js-best-ski-moments-embla');

function startBestSkiMomentsEmbla() {
    const rootNode = document.querySelector('.js-best-ski-moments-embla');
    const viewportNode = rootNode.querySelector('.embla__viewport');
    const options = { loop: false };
    const emblaApi = EmblaCarousel(viewportNode, options);

    const prevBtnNode = document.querySelector('.embla__prev');
    const nextBtnNode = document.querySelector('.embla__next');

    prevBtnNode.addEventListener('click', emblaApi.scrollPrev, false);
    nextBtnNode.addEventListener('click', emblaApi.scrollNext, false);

    const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
        const togglePrevNextBtnsState = () => {
            if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
            else prevBtn.setAttribute('disabled', 'disabled');

            if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
            else nextBtn.setAttribute('disabled', 'disabled');
        };

        emblaApi
            .on('select', togglePrevNextBtnsState)
            .on('init', togglePrevNextBtnsState)
            .on('reInit', togglePrevNextBtnsState);

        return () => {
            prevBtn.removeAttribute('disabled');
            nextBtn.removeAttribute('disabled');
        };
    };

    const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
        const scrollPrev = () => {
            emblaApi.scrollPrev();
        };
        const scrollNext = () => {
            emblaApi.scrollNext();
        };
        prevBtn.addEventListener('click', scrollPrev, false);
        nextBtn.addEventListener('click', scrollNext, false);

        const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
            emblaApi,
            prevBtn,
            nextBtn
        );

        return () => {
            removeTogglePrevNextBtnsActive();
            prevBtn.removeEventListener('click', scrollPrev, false);
            nextBtn.removeEventListener('click', scrollNext, false);
        };
    };

    addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode);
}

$(document).on('layoutForBestSkiMomentsEmblaIsCreated', function () {
    startBestSkiMomentsEmbla();
});
